import {Component, OnInit} from '@angular/core';
import {CertificadosObservacoesService} from "./certificados-observacoes.service";
import {CertificadosObservacoesModel} from "./certificados-observacoes.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";

declare var swal: any;

@Component({
  selector: 'app-certificados-observacoes',
  templateUrl: './certificados-observacoes.component.html'
})
export class CertificadosObservacoesComponent extends Components implements OnInit {

  observacoes: CertificadosObservacoesModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private observacoesService: CertificadosObservacoesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'certificados-observacoes'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.observacoesService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.observacoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.observacoes);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(observacao) {
    let observacoes = this.observacoes;
    let observacoesService = this.observacoesService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarObservacao')+observacao.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(observacoes);
        }

        let index = observacoes.indexOf(observacao);
        observacoes.splice(index, 1);

        observacoesService.apagar(observacao.id_observacao)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.observacoes = observacoes;
            },
            err => {
              // Revert the view back to its original state
              observacoes.splice(index, 0, observacao);
              self.observacoes = observacoes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.observacoesService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.observacoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados_observacoes/certificados-observacoes.component.ts